import { useContext } from "react";
import { AppContext } from "@/App";
import { motion } from "framer-motion";
import { Wifi, Droplets, BatteryCharging, Armchair } from "lucide-react";

const FLEET = [
  {
    id: "sclass",
    img: "https://images.unsplash.com/photo-1680451553374-09d8d6a1ca58?auto=format&fit=crop&w=1600&q=60",
    wide: true,
  },
  {
    id: "eclass",
    img: "https://images.unsplash.com/photo-1764090317825-9b76e437c8d8?auto=format&fit=crop&w=1100&q=60",
  },
  {
    id: "vclass",
    img: "https://images.unsplash.com/photo-1765461734605-34657fa04db2?auto=format&fit=crop&w=1100&q=60",
  },
];

export default function Fleet() {
  const { t } = useContext(AppContext);
  const specs = [
    { icon: Wifi, label: t.fleet.specs.wifi },
    { icon: Droplets, label: t.fleet.specs.water },
    { icon: BatteryCharging, label: t.fleet.specs.charger },
    { icon: Armchair, label: t.fleet.specs.leather },
  ];

  const handleMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
  };

  return (
    <section id="flotta" data-testid="fleet-showcase-section" className="mx-auto max-w-7xl px-4 py-24 sm:px-6">
      <p className="label-accent">02 — {t.fleet.label}</p>
      <h2 className="font-display mt-3 text-3xl font-medium text-amber-100/90 sm:text-4xl">{t.fleet.title}</h2>
      <p className="mt-3 max-w-xl text-neutral-400">{t.fleet.sub}</p>

      <div className="mt-12 grid gap-5 md:grid-cols-2">
        {FLEET.map((car, i) => (
          <motion.div
            key={car.id}
            data-testid={`fleet-card-${car.id}`}
            onMouseMove={handleMove}
            initial={{ opacity: 0, y: 56 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className={`card-surface group relative overflow-hidden ${car.wide ? "md:col-span-2" : ""}`}
          >
            <div
              className="pointer-events-none absolute inset-0 z-10 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
              style={{ background: "radial-gradient(420px circle at var(--mx, 50%) var(--my, 50%), rgba(212,175,55,0.16), transparent 65%)" }}
            />
            <div className={`relative overflow-hidden ${car.wide ? "h-64 sm:h-96" : "h-56"}`}>
              <img
                src={car.img}
                alt={t.vehicles[car.id].name}
                loading="lazy"
                className="h-full w-full object-cover grayscale-[35%] transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C0E] via-transparent to-transparent" />
              <div className="absolute bottom-4 left-5">
                <h3 className="font-display text-2xl font-semibold text-white">{t.vehicles[car.id].name}</h3>
                <p className="text-xs text-neutral-400">{t.vehicles[car.id].desc}</p>
              </div>
              {car.credit && (
                <span className="absolute bottom-2 right-3 text-[9px] text-neutral-500">{car.credit}</span>
              )}
            </div>
            <div className="flex flex-wrap gap-4 px-5 py-4">
              {specs.map(({ icon: Icon, label }) => (
                <span key={label} className="flex items-center gap-1.5 text-xs text-neutral-400">
                  <Icon className="h-3.5 w-3.5 text-[#D4AF37]" /> {label}
                </span>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
